import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EEstimationPeriods, TOfferValuationData } from '../types';

export enum EActionTypes {
  Request = 'offerValuation/request',
  Success = 'offerValuation/success',
  Failure = 'offerValuation/failure',
  SetEstimationPeriod = 'offerValuation/setEstimationPeriod',
}

export const requestAction = actionGenerator<EActionTypes.Request>(EActionTypes.Request);
export const successAction = actionGenerator<EActionTypes.Success, TOfferValuationData>(EActionTypes.Success);
export const failureAction = actionGenerator<EActionTypes.Failure>(EActionTypes.Failure);
export const setEstimationPeriod = actionGenerator<EActionTypes.SetEstimationPeriod, EEstimationPeriods>(
  EActionTypes.SetEstimationPeriod,
);

export type TOfferValuationActions =
  | ReturnType<typeof requestAction>
  | ReturnType<typeof successAction>
  | ReturnType<typeof failureAction>
  | ReturnType<typeof setEstimationPeriod>;
